import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/components/LoginPage'
import RegisterPage from '@/components/RegisterPage'
import EmailVerificationPage from '@/components/EmailVerificationPage'
import ResetPasswordRequestPage from '@/components/ResetPasswordRequestPage'
import ResetPasswordPage from '@/components/ResetPasswordPage'
import ProfilePage from '@/components/ProfilePage'
import BalancePage from '@/components/BalancePage'
import Deliveries from '@/components/Deliveries'
import DeliveryView from '@/components/DeliveryView'
import DeliveryEdit from '@/components/DeliveryEdit'
import UsersPage from '@/components/UsersPage'
import CouriersPage from '@/components/CouriersPage'
import Messages from '@/components/Messages'
import MobileApplicationPage from '@/components/MobileApplicationPage'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Deliveries',
      component: Deliveries,
      meta: {
        allowAuthenticated: true
      }
    },
    {
      path: '/delivery/new',
      name: 'DeliveryEdit',
      component: DeliveryEdit,
      meta: {
        allowAuthenticated: true
      }
    },
    {
      path: '/delivery/:id',
      name: 'DeliveryView',
      component: DeliveryView,
      props: route => ({ id: route.params.id, expanded: true }),
      meta: {
        allowAuthenticated: true
      }
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/register',
      name: 'RegisterPage',
      component: RegisterPage,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/profile',
      name: 'ProfilePage',
      component: ProfilePage,
      meta: {
        allowAuthenticated: true
      }
    },
    {
      path: '/balance',
      name: 'BalancePage',
      component: BalancePage,
      meta: {
        allowAuthenticated: true
      }
    },
    {
      path: '/users',
      name: 'UsersPage',
      component: UsersPage,
      meta: {
        allowAuthenticated: true,
        allowAdmin: true
      }
    },
    {
      path: '/couriers',
      name: 'CouriersPage',
      component: CouriersPage,
      meta: {
        allowAuthenticated: true
      }
    },
    {
      path: '/emailVerification/:email/:code',
      name: 'emailVerification',
      component: EmailVerificationPage,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/emailVerified',
      name: 'emailVerified',
      component: EmailVerificationPage,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/resetPassword',
      name: 'resetPasswordRequest',
      component: ResetPasswordRequestPage,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/resetPassword/:email/:code',
      name: 'resetPassword',
      component: ResetPasswordPage,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/mobile-application',
      name: 'mobileApplication',
      component: MobileApplicationPage,
      meta: {
        allowAnonymous: true,
        allowAuthenticated: true
      }
    },
    {
      path: '/events',
      name: 'messages',
      component: Messages,
      meta: {
        allowAuthenticated: true
      }
    }
  ]
})
